// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn___FXe_","rowColumn":"style_rowColumn__5d7L7","center":"style_center__2sYMN"};